<!-- STANDARD Modal Header (SuperPrompt V8) -->
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Tax Owner Information (from original AngularJS) -->
<div class="tax-owner-info" [hidden]="minimise">
  <div class="info-row">
    <label>Tax Owner:</label>
    <span>{{ parentLEName }}</span>
  </div>
  <div class="info-row">
    <label>Tax Owner Functional Currency:</label>
    <span>{{ currencyValue }} - {{ currencyDesc }}</span>
  </div>
</div>

<!-- STANDARD Modal Body (SuperPrompt V8) -->
<div class="modal-body" [hidden]="minimise">
  <div class="form-horizontal">
    <!-- SMALL loader for form content only -->
    @if (showFormLoader) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
}
    
    @if (!showFormLoader) {
<div>
      <!-- Schedule C1 Data Table -->
      <table class="table table-bordered form-inline custom-table schedule-c1-table">
        <thead>
          <tr>
            <th colspan="10">{{ modalTitle }}</th>
          </tr>
        </thead>
        <tbody>
          <!-- Header Row -->
          <tr>
            <td></td>
            <td><strong>Note:</strong> <span>See the instructions if there are multiple recipients of remittances from the FDE or FB.</span></td>
            <td><strong><span style="text-align: center;">(a) Amount stated in functional currency of FDE or FB</span></strong></td>
            <td><strong><span style="text-align: center;">(b) Amount stated in functional currency of recipient</span></strong></td>
          </tr>
          
          <!-- Data Rows -->
          @for (row of irsF8858ScheduleC1Data; track itemTracker(i, row); let i = $index) {
<tr>
            <!-- Line Number -->
            <td style="padding-left: 5px !important;">{{ row.line_no }}.</td>
            
            <!-- Line Description -->
            <td style="padding-left: 5px !important;">{{ row.line_description }}</td>
            
            <!-- Column (a) - FDE/FB Amount -->
            <td class="col-md-2" style="padding-left: 5px !important; text-align: center;">
              @if (row.propertyType === '7') {
<div>
                <input 
                  style="text-align: right; padding-left: 5px;" 
                  type="text" 
                  class="form-control" 
                  [name]="row.attrib_name"
                  [disabled]="row.isEditableFlag === 'N'" 
                  placeholder="0" 
                  [ngModel]="row.value?.VALUE"
                  (ngModelChange)="row.value.VALUE = $event; validateInput(row, i)"/>
              </div>
}
            </td>
            
            <!-- Column (b) - Recipient Amount or Radio Buttons -->
            <td class="col-md-2" style="padding-left: 5px !important; text-align: center;">
              <!-- Number Input for propertyType1 === '7' -->
              @if (row.propertyType1 === '7') {
<div>
                <input 
                  style="text-align: right; padding-left: 5px;" 
                  type="text" 
                  class="form-control" 
                  [name]="row.value_1?.attrib_name"
                  [disabled]="row.isEditableFlag === 'N'" 
                  placeholder="0" 
                  [ngModel]="row.value_1?.VALUE"
                  (ngModelChange)="row.value_1.VALUE = $event; validateInput(row, i)"/>
              </div>
}
              
              <!-- Radio Buttons for propertyType === '13' (Yes/No) - logic from AngularJS -->
              @if (row.propertyType === '13') {
<div style="display: flex; justify-content: center;">
                <div class="radioBtnPosition">
                  <strong>Yes</strong>
                  <input 
                    type="radio" 
                    style="margin-left: 5px;" 
                    [value]="'Y'" 
                    [name]="'radio_row_' + i"
                    [checked]="row.value && row.value[0]?.VALUE === 'Y'"
                    [disabled]="row.isEditableFlag === 'N'"
                    (change)="onRadioBtnSelection(row, i, 'Y')">
                </div>
                <div class="radioBtnPosition">
                  <strong>No</strong>
                  <input 
                    type="radio" 
                    style="margin-left: 5px;" 
                    [value]="'N'" 
                    [name]="'radio_row_' + i"
                    [checked]="row.value && row.value[1]?.VALUE === 'N'"
                    [disabled]="row.isEditableFlag === 'N'"
                    (change)="onRadioBtnSelection(row, i, 'N')">
                </div>
              </div>
}
            </td>
          </tr>
}
        </tbody>
      </table>
    </div>
}
  </div>
</div>

<!-- STANDARD Footer (SuperPrompt V8) -->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName != 'Subsidiary') {
<button 
          class="save-button" 
          type="button" 
          [disabled]="isSaveClicked" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
}
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
